import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SectionHeadline } from '@/components/SectionHeadline';
import { Text } from '@/components/typography';
import { Button } from '@/components/buttons';
import { LINKS } from '@/constants/links';
import { RepresentativeExample } from '@/sections/RepresentativeExample';
import ProductComparisonTable from '../ProductComparasion';
import { showSpringOffer } from '@/utils/springOffer';
import { SPRING_OFFER_TRANSLATION_VALUES } from '@/constants/springOffer';
import { useBnplLimitsMinimal } from '@/api/skippay/featureFlags';
import { showChristmasOffer } from '@/utils/christmas';
import { CHRISTMAS_TRANSLATION_VALUES } from '@/constants/christmas';
function FilledComparisonTable() {
  const $ = _c(247);
  const {
    t
  } = useTranslation("ourProducts");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = showSpringOffer();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const shouldShowSpringOffer = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = showChristmasOffer();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const shouldShowChristmasOffer = t1;
  const isBnplLimitsMinimalEnabled = useBnplLimitsMinimal();
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div id="maxi" />;
    t3 = <div id="mini" />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="bgCircle absolute top-1/2 right-0 hidden translate-x-1/4 -translate-y-1/2 rotate-90 md:block" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t) {
    t5 = t("comparisonTable.title");
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <SectionHeadline className="mb-12 md:mb-16" anchorKey="ourProducts.comparisonTable.title">{t5}</SectionHeadline>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t) {
    t7 = t("comparisonTable.columns.mini.title");
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t) {
    t8 = t("comparisonTable.columns.maxi.title");
    $[11] = t;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t) {
    t9 = t("comparisonTable.columns.noPackage.title");
    $[13] = t;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t7 || $[16] !== t8 || $[17] !== t9) {
    t10 = {
      left: t7,
      center: t8,
      right: t9
    };
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t) {
    t11 = t("comparisonTable.categories.1.title");
    $[19] = t;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t) {
    t12 = t("comparisonTable.categories.1.items.1.title");
    $[21] = t;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t) {
    t13 = t("comparisonTable.categories.1.items.1.tooltip");
    $[23] = t;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t12 || $[26] !== t13) {
    t14 = {
      title: t12,
      tooltip: t13,
      left: true,
      center: true,
      right: true
    };
    $[25] = t12;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t) {
    t15 = t("comparisonTable.categories.1.items.2.title");
    $[28] = t;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t) {
    t16 = t("comparisonTable.categories.1.items.2.tooltip");
    $[30] = t;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t15 || $[33] !== t16) {
    t17 = {
      title: t15,
      tooltip: t16,
      left: true,
      center: true,
      right: true
    };
    $[32] = t15;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t) {
    t18 = t("comparisonTable.categories.1.items.3.title");
    $[35] = t;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t) {
    t19 = t("comparisonTable.categories.1.items.3.tooltip");
    $[37] = t;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t18 || $[40] !== t19) {
    t20 = {
      title: t18,
      tooltip: t19,
      left: true,
      center: true,
      right: false
    };
    $[39] = t18;
    $[40] = t19;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t) {
    t21 = t("comparisonTable.categories.1.items.4.title");
    $[42] = t;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t) {
    t22 = t("comparisonTable.categories.1.items.4.tooltip");
    $[44] = t;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== t21 || $[47] !== t22) {
    t23 = {
      title: t21,
      tooltip: t22,
      left: false,
      center: true,
      right: false
    };
    $[46] = t21;
    $[47] = t22;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] !== t) {
    t24 = t("comparisonTable.categories.1.items.5.title");
    $[49] = t;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] !== t) {
    t25 = t("comparisonTable.categories.1.items.5.tooltip");
    $[51] = t;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== t24 || $[54] !== t25) {
    t26 = {
      title: t24,
      tooltip: t25,
      left: false,
      center: true,
      right: false
    };
    $[53] = t24;
    $[54] = t25;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  let t27;
  if ($[56] !== t14 || $[57] !== t17 || $[58] !== t20 || $[59] !== t23 || $[60] !== t26) {
    t27 = [t14, t17, t20, t23, t26];
    $[56] = t14;
    $[57] = t17;
    $[58] = t20;
    $[59] = t23;
    $[60] = t26;
    $[61] = t27;
  } else {
    t27 = $[61];
  }
  let t28;
  if ($[62] !== t11 || $[63] !== t27) {
    t28 = {
      title: t11,
      items: t27
    };
    $[62] = t11;
    $[63] = t27;
    $[64] = t28;
  } else {
    t28 = $[64];
  }
  let t29;
  if ($[65] !== t) {
    t29 = t("comparisonTable.categories.2.title");
    $[65] = t;
    $[66] = t29;
  } else {
    t29 = $[66];
  }
  let t30;
  if ($[67] !== t) {
    t30 = t("comparisonTable.categories.2.items.1.title");
    $[67] = t;
    $[68] = t30;
  } else {
    t30 = $[68];
  }
  let t31;
  if ($[69] !== t) {
    t31 = t("comparisonTable.categories.2.items.1.tooltip");
    $[69] = t;
    $[70] = t31;
  } else {
    t31 = $[70];
  }
  let t32;
  if ($[71] !== t30 || $[72] !== t31) {
    t32 = {
      title: t30,
      tooltip: t31,
      left: true,
      center: true,
      right: true
    };
    $[71] = t30;
    $[72] = t31;
    $[73] = t32;
  } else {
    t32 = $[73];
  }
  let t33;
  if ($[74] !== t) {
    t33 = t("comparisonTable.categories.2.items.2.title");
    $[74] = t;
    $[75] = t33;
  } else {
    t33 = $[75];
  }
  let t34;
  if ($[76] !== t) {
    t34 = t("comparisonTable.categories.2.items.2.tooltip");
    $[76] = t;
    $[77] = t34;
  } else {
    t34 = $[77];
  }
  let t35;
  if ($[78] !== t33 || $[79] !== t34) {
    t35 = {
      title: t33,
      tooltip: t34,
      left: true,
      center: true,
      right: false
    };
    $[78] = t33;
    $[79] = t34;
    $[80] = t35;
  } else {
    t35 = $[80];
  }
  let t36;
  if ($[81] !== t) {
    t36 = t("comparisonTable.categories.2.items.3.title");
    $[81] = t;
    $[82] = t36;
  } else {
    t36 = $[82];
  }
  let t37;
  if ($[83] !== t) {
    t37 = t("comparisonTable.categories.2.items.3.tooltip");
    $[83] = t;
    $[84] = t37;
  } else {
    t37 = $[84];
  }
  let t38;
  if ($[85] !== t36 || $[86] !== t37) {
    t38 = {
      title: t36,
      tooltip: t37,
      left: false,
      center: true,
      right: false
    };
    $[85] = t36;
    $[86] = t37;
    $[87] = t38;
  } else {
    t38 = $[87];
  }
  let t39;
  if ($[88] !== isBnplLimitsMinimalEnabled || $[89] !== t) {
    t39 = !isBnplLimitsMinimalEnabled ? [{
      title: t("comparisonTable.categories.2.items.4.title"),
      tooltip: t("comparisonTable.categories.2.items.4.tooltip"),
      left: t("comparisonTable.categories.2.items.4.left"),
      center: t("comparisonTable.categories.2.items.4.center"),
      right: t("comparisonTable.categories.2.items.4.right")
    }] : [];
    $[88] = isBnplLimitsMinimalEnabled;
    $[89] = t;
    $[90] = t39;
  } else {
    t39 = $[90];
  }
  let t40;
  if ($[91] !== t) {
    t40 = t("comparisonTable.categories.2.items.5.title");
    $[91] = t;
    $[92] = t40;
  } else {
    t40 = $[92];
  }
  let t41;
  if ($[93] !== t) {
    t41 = t("comparisonTable.categories.2.items.5.tooltip");
    $[93] = t;
    $[94] = t41;
  } else {
    t41 = $[94];
  }
  let t42;
  if ($[95] !== t) {
    t42 = t("comparisonTable.categories.2.items.5.left");
    $[95] = t;
    $[96] = t42;
  } else {
    t42 = $[96];
  }
  let t43;
  if ($[97] !== t) {
    t43 = t("comparisonTable.categories.2.items.5.center");
    $[97] = t;
    $[98] = t43;
  } else {
    t43 = $[98];
  }
  let t44;
  if ($[99] !== t) {
    t44 = t("comparisonTable.categories.2.items.5.right");
    $[99] = t;
    $[100] = t44;
  } else {
    t44 = $[100];
  }
  let t45;
  if ($[101] !== t40 || $[102] !== t41 || $[103] !== t42 || $[104] !== t43 || $[105] !== t44) {
    t45 = {
      title: t40,
      tooltip: t41,
      left: t42,
      center: t43,
      right: t44
    };
    $[101] = t40;
    $[102] = t41;
    $[103] = t42;
    $[104] = t43;
    $[105] = t44;
    $[106] = t45;
  } else {
    t45 = $[106];
  }
  let t46;
  if ($[107] !== t32 || $[108] !== t35 || $[109] !== t38 || $[110] !== t39 || $[111] !== t45) {
    t46 = [t32, t35, t38, ...t39, t45];
    $[107] = t32;
    $[108] = t35;
    $[109] = t38;
    $[110] = t39;
    $[111] = t45;
    $[112] = t46;
  } else {
    t46 = $[112];
  }
  let t47;
  if ($[113] !== t29 || $[114] !== t46) {
    t47 = {
      title: t29,
      items: t46
    };
    $[113] = t29;
    $[114] = t46;
    $[115] = t47;
  } else {
    t47 = $[115];
  }
  let t48;
  if ($[116] !== t) {
    t48 = t("comparisonTable.categories.3.title");
    $[116] = t;
    $[117] = t48;
  } else {
    t48 = $[117];
  }
  let t49;
  if ($[118] !== t) {
    t49 = t("comparisonTable.categories.3.items.1.title");
    $[118] = t;
    $[119] = t49;
  } else {
    t49 = $[119];
  }
  let t50;
  if ($[120] !== t) {
    t50 = t("comparisonTable.categories.3.items.1.tooltip");
    $[120] = t;
    $[121] = t50;
  } else {
    t50 = $[121];
  }
  let t51;
  if ($[122] !== t49 || $[123] !== t50) {
    t51 = {
      title: t49,
      tooltip: t50,
      left: true,
      center: true,
      right: false
    };
    $[122] = t49;
    $[123] = t50;
    $[124] = t51;
  } else {
    t51 = $[124];
  }
  let t52;
  if ($[125] !== t) {
    t52 = t("comparisonTable.categories.3.items.2.title");
    $[125] = t;
    $[126] = t52;
  } else {
    t52 = $[126];
  }
  let t53;
  if ($[127] !== t) {
    t53 = t("comparisonTable.categories.3.items.2.tooltip");
    $[127] = t;
    $[128] = t53;
  } else {
    t53 = $[128];
  }
  let t54;
  if ($[129] !== t52 || $[130] !== t53) {
    t54 = {
      title: t52,
      tooltip: t53,
      left: true,
      center: true,
      right: false
    };
    $[129] = t52;
    $[130] = t53;
    $[131] = t54;
  } else {
    t54 = $[131];
  }
  let t55;
  if ($[132] !== t) {
    t55 = t("comparisonTable.categories.3.items.3.title");
    $[132] = t;
    $[133] = t55;
  } else {
    t55 = $[133];
  }
  let t56;
  if ($[134] !== t) {
    t56 = t("comparisonTable.categories.3.items.3.tooltip");
    $[134] = t;
    $[135] = t56;
  } else {
    t56 = $[135];
  }
  let t57;
  if ($[136] !== t) {
    t57 = t("comparisonTable.categories.3.items.3.left");
    $[136] = t;
    $[137] = t57;
  } else {
    t57 = $[137];
  }
  let t58;
  if ($[138] !== t) {
    t58 = t("comparisonTable.categories.3.items.3.center");
    $[138] = t;
    $[139] = t58;
  } else {
    t58 = $[139];
  }
  let t59;
  if ($[140] !== t) {
    t59 = t("comparisonTable.categories.3.items.3.right");
    $[140] = t;
    $[141] = t59;
  } else {
    t59 = $[141];
  }
  let t60;
  if ($[142] !== t55 || $[143] !== t56 || $[144] !== t57 || $[145] !== t58 || $[146] !== t59) {
    t60 = {
      title: t55,
      tooltip: t56,
      left: t57,
      center: t58,
      right: t59
    };
    $[142] = t55;
    $[143] = t56;
    $[144] = t57;
    $[145] = t58;
    $[146] = t59;
    $[147] = t60;
  } else {
    t60 = $[147];
  }
  let t61;
  if ($[148] !== t) {
    t61 = t("comparisonTable.categories.3.items.4.title");
    $[148] = t;
    $[149] = t61;
  } else {
    t61 = $[149];
  }
  let t62;
  if ($[150] !== t) {
    t62 = t("comparisonTable.categories.3.items.4.tooltip");
    $[150] = t;
    $[151] = t62;
  } else {
    t62 = $[151];
  }
  let t63;
  if ($[152] !== t) {
    t63 = t("comparisonTable.categories.3.items.4.left");
    $[152] = t;
    $[153] = t63;
  } else {
    t63 = $[153];
  }
  let t64;
  if ($[154] !== t) {
    t64 = t("comparisonTable.categories.3.items.4.center");
    $[154] = t;
    $[155] = t64;
  } else {
    t64 = $[155];
  }
  let t65;
  if ($[156] !== t) {
    t65 = t("comparisonTable.categories.3.items.4.right");
    $[156] = t;
    $[157] = t65;
  } else {
    t65 = $[157];
  }
  let t66;
  if ($[158] !== t61 || $[159] !== t62 || $[160] !== t63 || $[161] !== t64 || $[162] !== t65) {
    t66 = {
      title: t61,
      tooltip: t62,
      left: t63,
      center: t64,
      right: t65
    };
    $[158] = t61;
    $[159] = t62;
    $[160] = t63;
    $[161] = t64;
    $[162] = t65;
    $[163] = t66;
  } else {
    t66 = $[163];
  }
  let t67;
  if ($[164] !== t) {
    t67 = t("comparisonTable.categories.3.items.6.title");
    $[164] = t;
    $[165] = t67;
  } else {
    t67 = $[165];
  }
  let t68;
  if ($[166] !== t) {
    t68 = t("comparisonTable.categories.3.items.6.tooltip");
    $[166] = t;
    $[167] = t68;
  } else {
    t68 = $[167];
  }
  let t69;
  if ($[168] !== t67 || $[169] !== t68) {
    t69 = {
      title: t67,
      tooltip: t68,
      left: false,
      center: true,
      right: false
    };
    $[168] = t67;
    $[169] = t68;
    $[170] = t69;
  } else {
    t69 = $[170];
  }
  let t70;
  if ($[171] !== t) {
    t70 = shouldShowSpringOffer && {
      title: t("comparisonTable.categories.3.items.spring.title"),
      tooltip: t("comparisonTable.categories.3.items.spring.tooltip", SPRING_OFFER_TRANSLATION_VALUES),
      left: false,
      center: true,
      right: false
    };
    $[171] = t;
    $[172] = t70;
  } else {
    t70 = $[172];
  }
  let t71;
  if ($[173] !== t) {
    t71 = shouldShowChristmasOffer && {
      title: t("comparisonTable.categories.3.items.xmas.title"),
      tooltip: t("comparisonTable.categories.3.items.xmas.tooltip", {
        year: CHRISTMAS_TRANSLATION_VALUES.year
      }),
      left: false,
      center: true,
      right: false
    };
    $[173] = t;
    $[174] = t71;
  } else {
    t71 = $[174];
  }
  let t72;
  if ($[175] !== t51 || $[176] !== t54 || $[177] !== t60 || $[178] !== t66 || $[179] !== t69 || $[180] !== t70 || $[181] !== t71) {
    t72 = [t51, t54, t60, t66, t69, t70, t71].filter(Boolean);
    $[175] = t51;
    $[176] = t54;
    $[177] = t60;
    $[178] = t66;
    $[179] = t69;
    $[180] = t70;
    $[181] = t71;
    $[182] = t72;
  } else {
    t72 = $[182];
  }
  let t73;
  if ($[183] !== t48 || $[184] !== t72) {
    t73 = {
      title: t48,
      items: t72
    };
    $[183] = t48;
    $[184] = t72;
    $[185] = t73;
  } else {
    t73 = $[185];
  }
  let t74;
  if ($[186] !== t) {
    t74 = t("comparisonTable.categories.4.title");
    $[186] = t;
    $[187] = t74;
  } else {
    t74 = $[187];
  }
  let t75;
  if ($[188] !== t) {
    t75 = t("comparisonTable.categories.4.items.1.title");
    $[188] = t;
    $[189] = t75;
  } else {
    t75 = $[189];
  }
  let t76;
  if ($[190] !== t) {
    t76 = t("comparisonTable.categories.4.items.1.tooltip");
    $[190] = t;
    $[191] = t76;
  } else {
    t76 = $[191];
  }
  let t77;
  if ($[192] !== t75 || $[193] !== t76) {
    t77 = {
      title: t75,
      tooltip: t76,
      left: true,
      center: true,
      right: true
    };
    $[192] = t75;
    $[193] = t76;
    $[194] = t77;
  } else {
    t77 = $[194];
  }
  let t78;
  if ($[195] !== t) {
    t78 = t("comparisonTable.categories.4.items.2.title");
    $[195] = t;
    $[196] = t78;
  } else {
    t78 = $[196];
  }
  let t79;
  if ($[197] !== t) {
    t79 = t("comparisonTable.categories.4.items.2.tooltip");
    $[197] = t;
    $[198] = t79;
  } else {
    t79 = $[198];
  }
  let t80;
  if ($[199] !== t78 || $[200] !== t79) {
    t80 = {
      title: t78,
      tooltip: t79,
      left: false,
      center: true,
      right: false
    };
    $[199] = t78;
    $[200] = t79;
    $[201] = t80;
  } else {
    t80 = $[201];
  }
  let t81;
  if ($[202] !== t) {
    t81 = t("comparisonTable.categories.4.items.3.title");
    $[202] = t;
    $[203] = t81;
  } else {
    t81 = $[203];
  }
  let t82;
  if ($[204] !== t) {
    t82 = t("comparisonTable.categories.4.items.3.tooltip");
    $[204] = t;
    $[205] = t82;
  } else {
    t82 = $[205];
  }
  let t83;
  if ($[206] !== t81 || $[207] !== t82) {
    t83 = {
      title: t81,
      tooltip: t82,
      left: false,
      center: true,
      right: false
    };
    $[206] = t81;
    $[207] = t82;
    $[208] = t83;
  } else {
    t83 = $[208];
  }
  let t84;
  if ($[209] !== t) {
    t84 = t("comparisonTable.categories.4.items.4.title");
    $[209] = t;
    $[210] = t84;
  } else {
    t84 = $[210];
  }
  let t85;
  if ($[211] !== t) {
    t85 = t("comparisonTable.categories.4.items.4.tooltip");
    $[211] = t;
    $[212] = t85;
  } else {
    t85 = $[212];
  }
  let t86;
  if ($[213] !== t84 || $[214] !== t85) {
    t86 = {
      title: t84,
      tooltip: t85,
      left: false,
      center: true,
      right: false
    };
    $[213] = t84;
    $[214] = t85;
    $[215] = t86;
  } else {
    t86 = $[215];
  }
  let t87;
  if ($[216] !== t77 || $[217] !== t80 || $[218] !== t83 || $[219] !== t86) {
    t87 = [t77, t80, t83, t86];
    $[216] = t77;
    $[217] = t80;
    $[218] = t83;
    $[219] = t86;
    $[220] = t87;
  } else {
    t87 = $[220];
  }
  let t88;
  if ($[221] !== t74 || $[222] !== t87) {
    t88 = {
      title: t74,
      items: t87
    };
    $[221] = t74;
    $[222] = t87;
    $[223] = t88;
  } else {
    t88 = $[223];
  }
  let t89;
  if ($[224] !== t28 || $[225] !== t47 || $[226] !== t73 || $[227] !== t88) {
    t89 = [t28, t47, t73, t88];
    $[224] = t28;
    $[225] = t47;
    $[226] = t73;
    $[227] = t88;
    $[228] = t89;
  } else {
    t89 = $[228];
  }
  let t90;
  if ($[229] !== t10 || $[230] !== t89) {
    t90 = <ProductComparisonTable activeColumn="center" titles={t10} categories={t89} />;
    $[229] = t10;
    $[230] = t89;
    $[231] = t90;
  } else {
    t90 = $[231];
  }
  let t91;
  if ($[232] !== t) {
    t91 = t("comparisonTable.text");
    $[232] = t;
    $[233] = t91;
  } else {
    t91 = $[233];
  }
  let t92;
  if ($[234] !== t91) {
    t92 = <Text variant="p4" className="my-10 text-center">{t91}</Text>;
    $[234] = t91;
    $[235] = t92;
  } else {
    t92 = $[235];
  }
  let t93;
  if ($[236] === Symbol.for("react.memo_cache_sentinel")) {
    t93 = <div className="mx-auto mt-4 max-w-[47.5rem] md:my-16 lg:my-12"><RepresentativeExample className="bg-blue-50" /></div>;
    $[236] = t93;
  } else {
    t93 = $[236];
  }
  let t94;
  if ($[237] === Symbol.for("react.memo_cache_sentinel")) {
    t94 = LINKS();
    $[237] = t94;
  } else {
    t94 = $[237];
  }
  const t95 = t94.registration;
  let t96;
  if ($[238] !== t) {
    t96 = t("comparisonTable.cta");
    $[238] = t;
    $[239] = t96;
  } else {
    t96 = $[239];
  }
  let t97;
  if ($[240] !== t96) {
    t97 = <div className="pt-4"><Button variant="primary" align="center" size="lg" to={t95} testId="accountsRegistration" analyticsParam="accountsRegistration">{t96}</Button></div>;
    $[240] = t96;
    $[241] = t97;
  } else {
    t97 = $[241];
  }
  let t98;
  if ($[242] !== t6 || $[243] !== t90 || $[244] !== t92 || $[245] !== t97) {
    t98 = <>{t2}{t3}<div className="relative px-4" id="comparison-table">{t4}<div className="relative z-10">{t6}{t90}{t92}{t93}{t97}</div></div></>;
    $[242] = t6;
    $[243] = t90;
    $[244] = t92;
    $[245] = t97;
    $[246] = t98;
  } else {
    t98 = $[246];
  }
  return t98;
}
export default FilledComparisonTable;